export const oemUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3666/' : '/'
